//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  data: () => ({
    countryLocal: 'GB'
  }),
  computed: {
    ...mapGetters({
      countries: 'store/shippingCountries',
      country: 'store/shippingCountry'
    }),
    translatedCountries () {
      return this.countries.map((country) => {
        country.countryName = this.$tr(country.country)
        return country
      }).sort((a, b) => a.countryName.localeCompare(b.countryName))
    }
  },
  watch: {
    async countryLocal (country) {
      if (this.country === country) return
      await this.$store.commit('store/CHANGE_SHIPPING_COUNTRY', country)
    }
  },
  beforeMount () {
    this.countryLocal = this.country
  }
}
